customElements.define(
  "cart-shipping-bar",
  class extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector("[data-shipping-message]");
      this.progress = this.querySelector("[data-shipping-progress]");
      this.update();
      document.addEventListener("cart:updated", (e) => this.update(e.detail));
    }
    async update(cart) {
      if (!cart) {
        const res = await fetch("/cart.js");
        cart = await res.json();
      }
      const threshold = window.freeShippingThreshold || 0;
      if (!threshold) return;
      const total = cart.total_price;
      const pct = Math.min(total / threshold * 100, 100);
      this.progress.style.width = pct + "%";
      this.progress.parentElement.classList.toggle("hidden", pct >= 100);
      this.classList.toggle("hidden", cart.item_count === 0);
      if (pct >= 100) {
        this.message.textContent = this.achievedText();
      } else {
        const remaining = threshold - total;
        this.message.textContent = this.remainingText(this.formatMoney(remaining));
      }
    }
    achievedText() {
      return document.documentElement.lang === "bg" ? "Имате право на безплатна доставка! 🎉" : "You qualify for free shipping! 🎉";
    }
    remainingText(amount) {
      return document.documentElement.lang === "bg" ? `Добавете още ${amount} за безплатна доставка!` : `Spend ${amount} more for free shipping!`;
    }
    formatMoney(cents) {
      if (window.money_format) {
        const amount = (cents / 100).toFixed(2);
        const amountNoDecimals = Math.floor(cents / 100).toString();
        const amountWithCommaSeparator = amount.replace(".", ",");
        return window.money_format.replace(/\{\{\s*amount\s*\}\}/g, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals).replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator);
      }
      const currency = window.Shopify?.currency?.active || "EUR";
      try {
        return new Intl.NumberFormat(navigator.language || "en", {
          style: "currency",
          currency,
          minimumFractionDigits: 2
        }).format(cents / 100);
      } catch {
        return `€${(cents / 100).toFixed(2)}`;
      }
    }
  }
);
